import {t} from "@lingui/core/macro";

import {Strut} from "@khanacademy/wonder-blocks-layout";
import Pill from "@khanacademy/wonder-blocks-pill";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";

type Props = {
    slug: string;
    subjectPercentage: number;
};

export const SubjectPercentagePill = ({
    slug,
    subjectPercentage,
}: Props): React.ReactElement | null => {
    return (
        <>
            <Strut size={spacing.xxSmall_6} />
            <Pill kind="neutral" size="small" testId="subject-percentage-pill">
                <LabelMedium tag="span">{t`${subjectPercentage}%`}</LabelMedium>
            </Pill>
        </>
    );
};
